import React, { memo } from 'react';

// Libraries
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';

// Components
import SocialIcons from '../SocialIcon/SocialIcons';
import FooterMenu, { Footer } from './Footer';

// Data
import useFooterData from './FooterData';
import Markdown from "react-markdown";

const iconData = [
  {
    color: '#828282',
    link: 'https://www.facebook.com/',
    icon: 'fab fa-facebook-f',
  },
  {
    color: '#828282',
    link: 'https://dribbble.com/',
    icon: 'fab fa-dribbble',
  },
  {
    color: '#828282',
    link: 'https://twitter.com/',
    icon: 'fab fa-twitter',
  },
  {
    color: '#828282',
    link: 'https://www.instagram.com/',
    icon: 'fab fa-instagram',
  },
];

const FooterStyle03 = (props) => {
  const footerData = useFooterData(); // Utilisation du hook

  return (
    <Footer theme={props.theme} className={`${props.className ? ` ${props.className}` : ''} footer-style-03`}>
      <div className="py-[6%] lg:py-[8%] md:py-[50px] md:pb-0 xs:py-[50px]">
        <Container>
          <Row className="justify-between md:justify-start">
            <Col lg={{ span: 3, order: 0 }} sm={{ span: 6, order: 1 }} className="md:mb-[40px] xs:mb-[25px]">
              <span className="font-serif font-medium block text-themecolor mb-[20px] xs:mb-[10px]">
                À propos de nous :
              </span>
              <p className="md:w-9/12 xs:w-full">
                SPEED TUNISIA SARL est une société de représentation, 
                d’importation et de distribution dans les ingrédients, 
                les consommables 
                et le matériel en B2B dans le domaine agroalimentaire.
              </p>
            </Col>
            <FooterMenu
              data={footerData} // Utilisation des données dynamiques
              lg={{ span: 4, order:  0}}
              md={6}
              sm={{ span: 6, order: 2 }}
              className="xl:px-[15px] text-center md:mb-[40px] xs:mb-[25px]"
              titleClass="capitalize leading-[20px] mb-[25px]"
            />
          </Row>
        </Container>
      </div>
      <div className="py-[35px] border-t border-[#ffffff1a]">
        <Container>
          <Row>
            <Col md={3} className="sm:mb-[20px]">
              <Link aria-label="link" to="/" className="sm:flex sm:justify-center">
                <img src="/assets/logo.png" alt="logo" width="111" height="36" />
              </Link>
            </Col>
            <Col md={6} className="flex justify-center sm:mb-[20px]">
              <p className="mb-0 xs:text-center">
                Copyright © {new Date().getFullYear()} {' '}
                <a
                  aria-label="themezaa"
                  className="text-themecolor underline-none underline-offset-4"
                  rel="noreferrer"
                  target="_blank"
                  href="#"
                >
                  Xylario
                </a>
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </Footer>
  );
};

FooterStyle03.defaultProps = {
  logo: '/assets/img/webp/logo-white.webp',
};

FooterStyle03.propTypes = {
  className: PropTypes.string,
  logo: PropTypes.string,
};

export default memo(FooterStyle03);